import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import "./footer.scss"
import Logo from "./images/footer-logo.png"
function Footer() {
    const currentYear = new Date().getFullYear()

    const services = [
        { url: "/services/seo-agency-saigon", text: "SEO Agency Saigon" },
        { url: "/services/web-design-saigon", text: "Web Design Agency Saigon" },
        { url: "/services/marketing-agency-saigon", text: "Marketing Agency Saigon" },
        { url: "/services/web-development-saigon", text: "Web Development Agency Saigon" },
        { url: "/services/jamstack-development", text: "Jamstack Development" },
        { url: "/services/hubspot-development", text: "Hubspot Development" },
        { url: "/services/headless-ecommerce", text: "Headless e-Commerce" },
        {
            url: "/services/wordpress-development",
            text: "Bespoke WordPress Development"
        },
        { url: "/services/support-services", text: "Support Services" },
        {
            url: "/services/digital-transformation",
            text: "Digital Transformation"
        }
    ]
    const social = [
        {
            id: 0,
            url: "https://www.facebook.com/saigondigital2021",
            text: "Facebook",
            gaTag: "facebook_click"
        },
        {
            id: 1,
            url: "https://www.instagram.com/saigon.digital/",
            text: "Instagram",
            gaTag: "instagram_click"
        },
        {
            id: 2,
            url: "https://www.linkedin.com/company/saigon-digital/",
            text: "LinkedIn",
            gaTag: "linkedin_click"
        },
        {
            id: 3,
            url: "https://github.com/Saigon-Digital",
            text: "Github",
            gaTag: "github_click"
        },
        {
            id: 4,
            url: "https://www.youtube.com/@saigon.digital",
            text: "Youtube",
            gaTag: "youtube_click"
        }
    ]

    return (
        <footer className="bg-[#1D2333] md:pt-[71px]">
            <div className="container w-full">
                <div className="footer-toggle hidden md:grid md:grid-cols-2 md:gap-x-5 md:gap-y-10 md:border-b-[0.28px] md:border-solid md:border-white md:pb-[61px] lg:grid-cols-4">
                    <div className="footer-services">
                        <div className="mb-8 text-xs font-medium uppercase leading-8 text-[#CDCDCD]">
                            what we do
                        </div>
                        <ul>
                            {services.map((item, ix) => (
                                <li key={ix}>
                                    <Link to={item.url}>{item.text}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="mb-8  text-xs font-medium uppercase leading-8 text-[#CDCDCD]">
                            get in touch
                        </div>
                        <div>
                            <ul>
                                <li>
                                    <a
                                        href="mailto:hello@saigon.digital"
                                        aria-label="contact email"
                                    >
                                        hello@saigon.digital
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="tel:+84332364293"
                                        aria-label="contact phone"
                                    >
                                        +84332364293
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-social">
                        <div className="mb-8  text-xs font-medium uppercase leading-8 text-[#CDCDCD]">
                            we're social
                        </div>
                        <ul>
                            {social.map((item, ix) => (
                                <li
                                    onClick={() => {
                                        window.dataLayer.push({
                                            event: item.gaTag,
                                            eventCategory: "button_click"
                                        })
                                    }}
                                    key={ix}
                                    className="text-base font-normal leading-8 text-white"
                                >
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        aria-label="Go to social media"
                                    >
                                        {item.text}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div
                        className="footer-address"
                        aria-label="contact address"
                    >
                        <div className="mb-8 text-xs font-medium uppercase leading-8 text-[#CDCDCD]">
                            Studio
                        </div>
                        <div>
                            <a
                                href="https://www.google.com/maps/place/Saigon+Digital/@10.7790493,106.7235249,15z/data=!4m6!3m5!1s0x43c49368de8fdf61:0x66eee35f6b024da6!8m2!3d10.7790493!4d106.7235249!16s%2Fg%2F11tct67vn4?entry=ttu"
                                target="_blank"
                                className="text-white"
                                aria-label="Go to address"
                            >
                                19 To Huu, Thu Thiem Ward, Thu Duc City, Ho Chi
                                Minh City, Vietnam
                            </a>

                            <div className="mt-7 aspect-video">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15677.683118349454!2d106.7235249!3d10.7790493!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43c49368de8fdf61%3A0x66eee35f6b024da6!2sSaigon%20Digital!5e0!3m2!1sen!2s!4v1706754417757!5m2!1sen!2s"
                                    className="h-full w-full"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-info flex flex-col items-center justify-between pt-[24px] md:flex-row md:pt-[53px]">
                    <div className="footer-info-left flex flex-col items-center justify-between gap-y-3 md:flex-row md:gap-x-14">
                        <Link to="/" aria-label="Go to homepage">
                            <div className="footer-logo max-w-[131px]">
                                <StaticImage src="./images/footer-logo.png" />
                            </div>
                        </Link>

                        <div className="social-icon text-2xl leading-[45.5px] text-white">
                            <a
                                target="_blank"
                                href="https://www.facebook.com/saigondigital2021"
                                aria-label="Go to social media"
                            >
                                <i className="fa-brands fa-facebook-square mr-4"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://www.instagram.com/saigon.digital/"
                                aria-label="Go to social media"
                            >
                                <i className="fa-brands fa-instagram-square mr-4"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://twitter.com/SaigonDigital"
                                aria-label="Go to social media"
                            >
                                <i className="fa-brands fa-twitter mr-4"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://www.linkedin.com/company/saigon-digital/"
                                aria-label="Go to social media"
                            >
                                <i className="fa-brands fa-linkedin mr-4"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://www.youtube.com/@saigon.digital"
                                aria-label="Go to social media"
                            >
                                <i className="fa-brands fa-youtube mr-4"></i>
                            </a>
                        </div>
                    </div>
                    <div className="footer-info-right flex flex-col items-center lg:flex-row">
                        <a
                            href="https://cms.saigon.digital/wp-content/uploads/2023/11/Privacy_Policy_Version_2023.pdf"
                            target="_blank"
                            className="inline-block text-xs leading-8 text-white md:text-sm"
                        >
                            Privacy Policy
                        </a>
                        <span className="mx-2  hidden h-3 w-[1px] bg-white lg:inline-block"></span>
                        <a
                            href="https://cms.saigon.digital/wp-content/uploads/2023/12/SD_-_T_C_SD_Version_04.12.2023.pdf"
                            target="_blank"
                            className="inline-block text-xs leading-8 text-white md:text-sm"
                        >
                            Terms & Conditions
                        </a>
                        <span className="mx-2 hidden h-3 w-[1px] bg-white lg:inline-block"></span>
                        <p className="text-xs leading-8 text-white md:text-sm">
                            © {currentYear} SaigonDigital. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
